module.exports = "/images/af61c5bfe9a48562251ab6cffdebb688.svg";